import React from "react";
import * as io from "io-ts";
import createGlobalState from "@ui/lib/createGlobalState";
import Switch from "@ui/Switch";
import t from "../../../i18n";
import { useSettings } from "../../../api/useSettings";

export const usePublicationFlagDisplay = createGlobalState({
  storage: "session",
  key: "publicationFlagDisplay",
  type: io.boolean,
  scoped: true,
});

function ToggleAnalysesPublicationFlagDisplay({
  projectId,
  allAnalysesMode = false,
}: {
  projectId: string;
  allAnalysesMode?: boolean;
}) {
  const settings = useSettings();
  const [publicationFlagDisplay, setPublicationDisplay] = usePublicationFlagDisplay({
    defaultValue: settings.DISPLAY_PUBLICATION_MARKERS,
    scope: projectId,
  });

  if (!settings.FLEET_VIEW_ENABLED) return null;

  return (
    <Switch
      disabled={allAnalysesMode}
      checked={publicationFlagDisplay}
      onChange={() => setPublicationDisplay(state => !state)}
    >
      {t("showPublishedAnalysis.text")}
    </Switch>
  );
}

export default React.memo(ToggleAnalysesPublicationFlagDisplay);
